import React from 'react';
import { CheckIcon } from 'lucide-react';
import { mapIncludes, modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-16 md:py-24" data-id="element-252" data-mp="1026qg5u708yk">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-253" data-mp="l4eetorro4pn">
        <header className="mx-auto max-w-narrow text-center" data-id="element-254" data-mp="q266choi1otb">
          <h2 className="font-display text-[2rem] font-extrabold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-255" data-mp="q2obk3t53ddd">
            Sistema completo: 100 mapas visuales
            <br data-id="element-256" data-mp="1iq21hhyf78nz" />
            <span className="text-blue-600" data-id="element-257" data-mp="1iqk7356z2z8k">+ 100 análisis de ejercicios reales</span>
          </h2>
        </header>

        <ul className="mx-auto mt-12 grid max-w-4xl gap-5 md:grid-cols-3" data-id="element-258" data-mp="1404kpn2tll8t">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-soft ring-1 ring-blue-100" data-id="element-259" data-mp="18yxpmr41k3xd">
              <span className={`h-1.5 w-12 rounded-full ${module.spine}`} aria-hidden="true" data-id="element-260" data-mp="21iw5xhyf3idy" />
              <h3 className="mt-5 font-display text-xl font-extrabold tracking-tight text-ink" data-id="element-261" data-mp="2vgbzba8mrxv7">
                {module.title}
              </h3>
              <p className="mt-1 font-display text-sm font-extrabold uppercase tracking-[0.12em] text-blue-600" data-id="element-262" data-mp="355dh95yqkpbt">
                {module.detail}
              </p>
              <p className="mt-4 text-blue-900/75" data-id="element-263" data-mp="30dm01m1gzvyc">{module.summary}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-4xl rounded-2xl bg-white p-7 shadow-soft ring-1 ring-blue-100 md:p-9" data-id="element-264" data-mp="3e84v1cf33x6m">
          <h3 className="font-display text-lg font-extrabold tracking-tight text-blue-600 md:text-xl" data-id="element-265" data-mp="3o4hktz7idqw3">
            En cada mapa:
          </h3>
          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-266" data-mp="3j6pw1e25ukw4">
            {mapIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-267" data-mp="1tr9p85bplb9e">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-600" data-id="element-268" data-mp="1orx2dkku846t">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-269" data-mp="2egud3rsnvgac" />
                </span>
                <span className="text-ink" data-id="element-270" data-mp="2ii5u58xgyt6x">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}